/* omc-cart-upsell v1 - Complete the uniform cart upsell. Native, no app. */
(function(){
  var CORE = ['agony-running-tee','suffer-running-shorts','blister-running-socks','brow-mop-running-cap'];
  var MAX = 3, cache = {}, busy = false;
  function money(p){ return '\u00A3' + (p/100).toFixed(2).replace(/\.00$/,''); }
  function isUK(cart){
    if (window.__OMC_COUNTRY && window.__OMC_COUNTRY !== 'GB') return false;
    if (cart && cart.currency && cart.currency !== 'GBP') return false;
    return true;
  }
  function getProduct(h){
    if (cache[h]) return Promise.resolve(cache[h]);
    return fetch('/products/' + h + '.js', {credentials:'same-origin'})
      .then(function(r){ return r.json(); }).then(function(p){ cache[h]=p; return p; });
  }
  function img(p){
    var s = p.featured_image || (p.images && p.images[0]) || '';
    if (!s) return '';
    if (s.indexOf('//') === 0) s = 'https:' + s;
    return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=400';
  }
  function card(p){
    var single = p.variants.length === 1;
    var v = single ? p.variants[0] : null;
    var el = document.createElement('div');
    el.className = 'omc-upsell__card';
    var im = img(p);
    el.innerHTML = (im ? '<div class="omc-upsell__imgwrap"><img class="omc-upsell__img" src="'+im+'" alt="" loading="lazy"></div>' : '') +
      '<div class="omc-upsell__body"><p class="omc-upsell__title">'+p.title+'</p>' +
      '<p class="omc-upsell__price">'+money(p.price)+'</p></div>';
    var btn = document.createElement(single ? 'button' : 'a');
    btn.className = 'omc-upsell__btn';
    if (single) {
      btn.type = 'button'; btn.textContent = 'ADD';
      btn.addEventListener('click', function(){
        if (busy) return; busy = true; btn.textContent = 'ADDING\u2026';
        fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, credentials:'same-origin', body: JSON.stringify({id:v.id, quantity:1})})
          .then(function(){ window.location.reload(); })
          .catch(function(){ busy=false; btn.textContent='ADD'; });
      });
    } else {
      btn.href = '/products/' + p.handle;
      var on = (p.options && p.options[0] && (p.options[0].name || p.options[0])) || '';
      btn.textContent = /size/i.test(on) ? 'PICK SIZE' : 'CHOOSE';
    }
    el.appendChild(btn);
    return el;
  }
  function build(ps, cart){
    var wrap = document.createElement('section');
    wrap.className = 'omc-upsell';
    var one = cart.item_count === 1 && isUK(cart);
    var head = document.createElement('div');
    head.className = 'omc-upsell__head';
    head.innerHTML = '<p class="omc-upsell__kicker">Complete the uniform</p>' +
      '<p class="omc-upsell__sub">' + (one ? 'Add one more item and your UK shipping is free.' : 'The rest of the kit, while you\u2019re here.') + '</p>';
    var grid = document.createElement('div');
    grid.className = 'omc-upsell__grid';
    ps.slice(0, MAX).forEach(function(p){ grid.appendChild(card(p)); });
    wrap.appendChild(head); wrap.appendChild(grid);
    return wrap;
  }
  function anchor(){ return document.querySelector('.cart-items') || document.querySelector('[class*=cart-item]'); }
  function render(){
    if (!anchor()) return;
    fetch('/cart.js', {headers:{Accept:'application/json'}, credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var old = document.querySelector('.omc-upsell');
        if (old && old.parentNode) old.parentNode.removeChild(old);
        if (!cart.item_count) return;
        var have = {};
        (cart.items||[]).forEach(function(i){ if (i.handle) have[i.handle] = true; });
        var miss = CORE.filter(function(h){ return !have[h]; });
        if (!miss.length) return;
        Promise.all(miss.map(getProduct)).then(function(ps){
          ps = ps.filter(function(p){ return p && p.available; });
          if (!ps.length) return;
          var a = anchor();
          if (!a || !a.parentNode) return;
          if (document.querySelector('.omc-upsell')) return;
          a.parentNode.insertBefore(build(ps, cart), a.nextSibling);
        });
      }).catch(function(){});
  }
  var t=null;
  function schedule(){ clearTimeout(t); t=setTimeout(render, 250); }
  if (window.fetch) {
    var orig = window.fetch;
    window.fetch = function(){
      var u='';
      try{ u = (typeof arguments[0]==='string') ? arguments[0] : (arguments[0]&&arguments[0].url)||''; }catch(e){}
      var pr = orig.apply(this, arguments);
      if (/\/cart\/(add|change|update)/.test(u)) { pr.then(function(){ busy=false; schedule(); }).catch(function(){}); }
      return pr;
    };
  }
  function start(){ schedule(); new MutationObserver(function(){ if(!document.querySelector('.omc-upsell')) schedule(); }).observe(document.body,{childList:true,subtree:true}); }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', start); else start();
})();